import {
  GET_BUDGET,
  GET_BUDGET_SUCCESS,
  GET_BUDGET_FAIL,
  DELETE_BUDGET,
  DELETE_BUDGET_SUCCESS,
  DELETE_BUDGET_FAIL,
  UPDATE_BUDGET,
  UPDATE_BUDGET_SUCCESS,
  UPDATE_BUDGET_FAIL,
  ADD_NEW_BUDGET,
  ADD_BUDGET_SUCCESS,
  ADD_BUDGET_FAIL,
  BUDGET_LOADING,
  BUDGET_RESET,
} from "./actionType";

export const resetBudgetState = (actionType) => ({
  type: BUDGET_RESET,
  payload: { actionType },
});

export const getBudgetSuccess = (actionType, data) => ({
  type: GET_BUDGET_SUCCESS,
  payload: { actionType, data },
});

export const getBudgetFail = (actionType, error) => ({
  type: GET_BUDGET_FAIL,
  payload: { actionType, error },
});

export const getBudget = data => ({
  type: GET_BUDGET,
  payload: data,
});

export const getBudgetLoading = () => ({
  type: BUDGET_LOADING
});

export const deleteBudget = data => ({
  type: DELETE_BUDGET,
  payload: data,
});

export const deleteBudgetSuccess = data => ({
  type: DELETE_BUDGET_SUCCESS,
  payload: data,
});

export const deleteBudgetFail = error => ({
  type: DELETE_BUDGET_FAIL,
  payload: error,
});

export const updateBudget = data => ({
  type: UPDATE_BUDGET,
  payload: data,
});

export const updateBudgetFail = error => ({
  type: UPDATE_BUDGET_FAIL,
  payload: error,
});

export const updateBudgetSuccess = data => ({
  type: UPDATE_BUDGET_SUCCESS,
  payload: data,
});

export const addNewBudget = data => ({
  type: ADD_NEW_BUDGET,
  payload: data,
});

export const addBudgetSuccess = data => ({
  type: ADD_BUDGET_SUCCESS,
  payload: data,
});

export const addBudgetFail = error => ({
  type: ADD_BUDGET_FAIL,
  payload: error,
});